import { render, staticRenderFns } from "./WidgetsMenu.vue?vue&type=template&id=5351a0b6"
import script from "./WidgetsMenu.vue?vue&type=script&lang=ts"
export * from "./WidgetsMenu.vue?vue&type=script&lang=ts"
import style0 from "./WidgetsMenu.vue?vue&type=style&index=0&id=5351a0b6&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports